import { createApp } from 'vue'
import App from './App.vue'
import router from './routes'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap'
import axios from 'axios'

window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;

axios.defaults.baseURL = 'https://starmate.co.in/'
createApp(App).use(router).mount('#app')

